<template>
  <div class="user-order">
    <div class="order-header">
      <div class="title">我的订单</div>
      <div class="more">
        <span class="text" @click="order">查看全部订单</span>
        <img src="@/assets/right.png" alt="查看全部订单" width="14" height="14">
      </div>
    </div>
    <div class="order-main">
      <div class="order-item" v-for="(item,idx) in orderList" :key="idx" @click="onNavigate(item)">
        <div class="icon">
          <img :src="item.icon" :alt="item.name" width="24" height="24">
        </div>
        <span class="name">{{item.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      orderList: [
        {
          icon: require("@/assets/order01.png"),
          name: '待支付',
          url:'/order',
          count: '',
          status : 2
        },
        {
          icon: require("@/assets/order02.png"),
          name: '待发货',
          url:'/order',
          count: '',
          status:0
        },
        {
          icon: require("@/assets/order03.png"),
          name: '待收货',
          url:'/order',
          count: '',
          status : 4
        },
        {
          icon: require("@/assets/order04.png"),
          name: '售后/退款',
          url:'/mine/refund/afterRefund',
          count: '',
          status : 404
        }
      ]
    }
  },
  methods:{
    order(){
      this.$router.push({
        path:'/order',
        query:{
          orderStatus : -1
        }
      })
    },
    // 跳转
    onNavigate(item) {
      this.$router.push({
        path: item.url,
        query:{
          orderStatus : item.status
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.user-order {
  height: 180px;
  background: #ffffff;
  padding: 0 12px;
  .order-header{
    margin-top: 66px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .title{
      height:22px;
      font-size:16px;
      font-weight:bold;
      line-height:22px;
      color:rgba(51,51,51,1);
      border-left: 4px solid #FE003B;
      padding-left: 8px;
    }
    .more{
      display: flex;
      justify-content: center;
      align-items: center;
      .text{
        height:20px;
        font-size:14px;
        font-weight:400;
        line-height:20px;
        color:rgba(254,0,59,1);
        margin-right: 4px;
      }
    }
  }
  .order-main{
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    .order-item{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 52px;
      .icon{
        display: flex;
        justify-content: center;
        align-items: center;
        width:46px;
        height:46px;
        background:linear-gradient(201deg,rgba(255,144,105,1) 0%,rgba(243,8,69,1) 100%);
        border-radius:50%;
      }
      .name{
        height:20px;
        font-size:14px;
        font-weight:500;
        line-height:20px;
        color:rgba(51,51,51,1);
        margin-top: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mine/modules/Order.vue